import FormPrivacyPolicyBlock from "./FormPrivacyPolicyBlock";

export default FormPrivacyPolicyBlock;